import { asyncRoute } from '../../router';

export default asyncRoute(() => import(/* webpackChunkName: "Lotteries" */ './components/Lotteries'));
